import { render, staticRenderFns } from "./SuppliersCategoriesList.vue?vue&type=template&id=08403a9d&scoped=true"
import script from "./SuppliersCategoriesList.vue?vue&type=script&lang=js"
export * from "./SuppliersCategoriesList.vue?vue&type=script&lang=js"
import style0 from "./SuppliersCategoriesList.vue?vue&type=style&index=0&id=08403a9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08403a9d",
  null
  
)

export default component.exports